import React from 'react';
import style from './NutritionInfoCard.module.css';

/**
 * 영양소 정보 리스트 카드
 *
 * @param {Array<{
 *   key: string, label: string, value: number, unit: string, important?: boolean
 * }>} items
 */
const NutritionInfoCard = ({ calorRecDtl }) => {

    return (
        <div className={style.card}>
            <h3 className={style.title}>영양소 정보</h3>
            <ul className={style.list}>
                {/* {items.map((it) => (
                    <li key={it.key} className={style.row}>
                        <span className={style.labelGroup}>
                            <span className={style.label}>{it.label}</span>
                            {it.important && <span className={style.badge}>중요</span>}
                        </span>
                        <span className={style.value}>
                            {it.value.toLocaleString()}<em>{it.unit}</em>
                        </span>
                    </li>
                ))} */}
                {/******************/}
                {/* 나트륨, 단백질 : 초과/정상 표시 */}
                {/* 칼로리, 탄수화물, 지방 : 초과시 별도 표시 */}
                {/* 해당 데이터를 조회할 DB 필요 */}
                {/******************/}
                <li className={style.row}>
                    <span className={style.labelGroup}>
                        <span className={style.label}>칼로리</span>
                        {/* {it.important && <span className={style.badge}>중요</span>} */}
                    </span>
                    <span className={style.value}>
                        {calorRecDtl.energy}<em>kcal</em>
                    </span>
                </li>
                <li className={style.row}>
                    <span className={style.labelGroup}>
                        <span className={style.label}>나트륨</span>
                        {/* {it.important && <span className={style.badge}>중요</span>} */}
                    </span>
                    <span className={style.value}>
                        {calorRecDtl.sodium}<em>mg</em>
                    </span>
                </li>
                <li className={style.row}>
                    <span className={style.labelGroup}>
                        <span className={style.label}>단백질</span>
                        {/* {it.important && <span className={style.badge}>중요</span>} */}
                    </span>
                    <span className={style.value}>
                        {calorRecDtl.protein}<em>g</em>
                    </span>
                </li>
                <li className={style.row}>
                    <span className={style.labelGroup}>
                        <span className={style.label}>탄수화물</span>
                        {/* {it.important && <span className={style.badge}>중요</span>} */}
                    </span>
                    <span className={style.value}>
                        {calorRecDtl.carbohydrate}<em>g</em>
                    </span>
                </li>
                <li className={style.row}>
                    <span className={style.labelGroup}>
                        <span className={style.label}>지방</span>
                        {/* {it.important && <span className={style.badge}>중요</span>} */}
                    </span>
                    <span className={style.value}>
                        {calorRecDtl.fat}<em>g</em>
                    </span>
                </li>
            </ul>
        </div>
    );
};

export default NutritionInfoCard;